import { PAGE_URL, PageNames } from '../Constants/PagesRoutes/PageURLs'

export const enableSidebarFeatures = (cmsConfig: any, sideBarData: any[]): void => {
  const { ENABLED_FEATURES } = cmsConfig || {}
  if (ENABLED_FEATURES?.BULK_OPS_RE_TRANSCODING === false) {
    const bulkOpsIndex = sideBarData.findIndex(
      (item) => item.path === PAGE_URL[PageNames.BlukUpdate],
    )
    if (bulkOpsIndex !== -1) {
      const bulkOpsReTranscodingIndex = sideBarData[bulkOpsIndex].child.findIndex(
        (item: any) => item.path === PAGE_URL[PageNames.BulkTranscoding],
      )
      if (bulkOpsReTranscodingIndex !== -1) {
        sideBarData[bulkOpsIndex].child.splice(bulkOpsReTranscodingIndex, 1)
      }
    }
  }
}
